import { postData } from '../helpers/ajax'

export default function checkAnswers() {
  
  const questions = document.querySelectorAll('.Question')

  // for each question in questions. this component was updated to support multiple questions, T2411-02306
  questions.forEach(question => {

    const answersInputs = question.querySelectorAll('.AnswersListItem-input')
    const checkChapterQuestionButton = question.querySelector('.js-chapter-question-submit-button')
    const answerFeedback = question.querySelector('.QuestionFeedback')

    

  if (checkChapterQuestionButton) {
    const questionObj = JSON.parse(question.dataset.question)
    const correctAnswer = questionObj.correctAnswer

    checkChapterQuestionButton.addEventListener('click', (evt) => {
      evt.preventDefault()
      self.targetButton = evt.currentTarget;
      const answersArr = Array.from(answersInputs)
      const answerSelected = answersArr.filter(answer => answer.checked)
      if (answerSelected.length) {
        question.classList.add('Question--answered')
        answersInputs.forEach(answer => {

          // an ugly way of checking the the answer is within the question that was answered
          if (answer.parentNode.parentNode.parentNode.parentNode != self.targetButton.parentNode.parentNode) {
            return;
          }
            answer.disabled = true
            if (answer.value === answerSelected[0].value) {
              if (answer.value === correctAnswer) {
                answer.parentNode.classList.toggle('AnswersListItem-answer--correct')
                answerFeedback.classList.toggle('QuestionFeedback--correct')
              } else {
                answer.parentNode.classList.toggle('AnswersListItem-answer--incorrect')
                answerFeedback.classList.toggle('QuestionFeedback--incorrect')
              }
            } else {
              if (answer.value === correctAnswer) {
                answer.parentNode.classList.toggle('AnswersListItem-answer--right')
              }
            }
        })
        // answersInputs.forEach(answer => answer.disabled = true)
        checkChapterQuestionButton.parentNode.remove()
      }
    })
  }

  });



  // const question = document.querySelector('.Question')
  var targetButton = null;

}
